import { localizationService } from '@shared-services/localization-service';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { useBookingContext } from '../../Context';
import { BookerStateContext } from '../../hooks/useRuntimeCalBookingState';
import { Host } from '../../types';
import { isPaidBooking, shouldShowFreePriceLabel } from '../../utils';
import BackButton from '../BackButton';
import { DudaParagraphWrapper } from '../ContainerQueryStyles';
import OuterContainer from './common/OuterContainer';
import {
    Card,
    Container,
    EventSubTitle,
    EventTitle,
    GroupedEventsTitle,
    StepItemsList,
} from './common/styles';

const { str } = localizationService;

export default function StaffMemberSelectionStep() {
    const bookerContext = useBookingContext();
    const [state, bookingActions] = useContext(BookerStateContext);
    const { title, isTitleVisible } = bookerContext.serviceProviderStage;
    const { events, showFreePrice } = bookerContext;

    const handleBack = () => {
        bookingActions.setEventSelection(null);
        bookingActions.setEventSlug(null);
        bookingActions.resetEditorStep();
    };
    const selectedEventHosts = state?.eventSelection?.hosts || [];

    if (selectedEventHosts.length === 0 || !state?.eventSelection) {
        return null;
    }

    const eventSelection = state.eventSelection;

    const onHostSelect = (hostId: number) => {
        bookingActions.setSelectedHostId(hostId);
        bookingActions.resetEditorStep();
    };

    const hasPreviousScreen = events.length > 1;
    // Paid vs free follows the booker widget listing (EventServerModel.priceInfo), not Cal API
    // fields on eventSelection. Join state.eventSelection.id to bookerContext.events[].calEventId.
    const selectedServerEvent = events.find(
        (e) => e.calEventId === eventSelection.id
    );
    const isPaid = !!selectedServerEvent && isPaidBooking(selectedServerEvent);

    const showPriceSubtitle = isPaid || shouldShowFreePriceLabel(showFreePrice);

    return (
        <OuterContainer data-auto='staff-member-selection-step'>
            <Container>
                <GroupedEventsTitle data-auto='staff-member-selection-step-grouped-events-title'>
                    <DudaParagraphWrapper>
                        {isTitleVisible && title}
                    </DudaParagraphWrapper>
                </GroupedEventsTitle>
                <EventSubTitle data-auto='staff-member-selection-step-event-subtitle'>
                    {showPriceSubtitle
                        ? `${eventSelection.title} | ${eventSelection.displayPrice}`
                        : eventSelection.title}
                </EventSubTitle>
                <StyledStepItemsList>
                    <Card
                        data-auto='anyone-available-staff-member-selection-step-item'
                        onClick={() => onHostSelect(-1)}
                    >
                        <EventTitle>
                            {str(
                                'ui.runtimessr.staffMemberSelection.anyoneAvailable'
                            )}
                        </EventTitle>
                    </Card>
                    {selectedEventHosts.map((host: Host) => (
                        <Card
                            key={'event-host-' + host.userId}
                            data-auto='staff-member-selection-step-item'
                            onClick={() => onHostSelect(host.userId)}
                        >
                            <EventTitle>{host.name}</EventTitle>
                        </Card>
                    ))}
                </StyledStepItemsList>
            </Container>
            {hasPreviousScreen && (
                <BackButtonWrapper>
                    <BackButton onClick={handleBack} />
                </BackButtonWrapper>
            )}
        </OuterContainer>
    );
}

const StyledStepItemsList = styled(StepItemsList)`
    margin-block-end: 24px;
`;

const BackButtonWrapper = styled.div`
    position: sticky;
    bottom: 0;
    background-color: ${({ theme }) => theme.bookerBackgroundColor};
    width: 100%;
    padding-block-end: 24px;
    margin-block-start: auto;
`;
